import template from './mapsAddress.html';
import controller from './mapsAddress.controller';

const mapsAddressComponent = {
    restrict: 'E',
    bindings: {
        getShapes: '=',
        setShapes: '='
    },
    controller,
    template

};

export default mapsAddressComponent;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/mapsAddress/mapsAddress.component.js
 **/